module.exports = __webpack_public_path__ + "img/friendly-pool-3.85c4e11c.jpg";